/* eslint-disable no-fallthrough */

import type {
  VersionChangeHandlerProps,
  VersionChangeManager,
} from "@indietabletop/appkit";
import type { SpaceGitsIndexes, SpaceGitsSchema } from "./database.ts";

type Manager = VersionChangeManager<SpaceGitsSchema, SpaceGitsIndexes>;

type HandlerProps = VersionChangeHandlerProps<
  SpaceGitsSchema,
  SpaceGitsIndexes
>;

function createGangsStore(manager: Manager) {
  const store = manager.createObjectStore("gangs", { keyPath: "id" });
  store.createIndex("createdTs", "createdTs");
  store.createIndex("updatedTs", "updatedTs");
  store.createIndex("rulesetVersion", "rulesetVersion");
}

function createSettingsStore(manager: Manager) {
  const store = manager.createObjectStore("settings", { keyPath: "id" });
  store.createIndex("updatedTs", "updatedTs");
}

/**
 * Migrating from v1 to v2 involves:
 *
 * - Adding a new settings store with appropriate indexes.
 */
function migrateToV2(manager: Manager) {
  createSettingsStore(manager);
}

export function migrateDatabase({ manager, event }: HandlerProps) {
  switch (event.oldVersion) {
    case 1: {
      migrateToV2(manager);
    }

    default: {
      console.info(`Migration from DB v${event.oldVersion} complete.`);
    }
  }
}

/**
 * Initializes database from scratch.
 *
 * This function should be updated every time a new migration is added to
 * make sure that migrated and new databases are always in sync.
 */
export function initDatabase({ manager }: HandlerProps) {
  createGangsStore(manager);
  createSettingsStore(manager);

  console.info("DB initialized.");
}
